// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"7d5bd971","70":"b076aabf","461":"0429ba65","830":"be7abf4f","860":"1f961811","971":"7b2a2514"}[chunkId] + ".css";
};